<template>
  <div v-if="!runnersLoading">
    <v-simple-table dense fixed-header :height="dataTableHeight" class="row-pointer"
      style="border-radius: 0px !important">
      <thead>
        <tr class="runnerDetails_header">
          <th class="text-left">Runner Details</th>
          <th class="text-center">Finishing Position</th>
          <th class="text-right">Total Placed</th>
          <th class="text-center">Bets</th>
        </tr>
      </thead>
      <tbody style="font-weight:500 !important">
        <tr v-for="runner in runners" :key="runner.tabNo"
          @click="setSelectedRunner(runner), $emit('dialog')">
          <td>{{runner.tabNo}} {{runner.name}}</td>
          <td class="text-center">{{runner.finalPosition}}</td>
          <td class="text-right">${{numeral(runner.betsValue).format('0,0.00')}}</td>
          <td class="text-center">{{runner.betsCount || '0'}}</td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-divider></v-divider>
    <v-simple-table dense style="border-radius: 0px !important">
      <thead>
        <tr>
          <td><b>Totals</b></td>
          <td></td>
          <td class="text-right">
            <span><b>${{allBetsTotal()}}</b></span>
          </td>
          <td class="text-center" style="width: 11%">
            <span><b>{{totalNoBets()}}</b></span>
          </td>
        </tr>
      </thead>
    </v-simple-table>
  </div>
  <v-skeleton-loader v-else type="table"></v-skeleton-loader>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import numeral from 'numeral'
import { loaders } from '@/store'

export default {
  name: 'RunnerDetails',
  props: {
    runners: {
      type: Array,
      default: () => []
    },
    dataTableHeight: {
      type: Number
    }
  },
  data () {
    return {
      numeral,
      dialog: false
    }
  },
  computed: {
    ...mapState(['selectedRunner', 'loading']),
    ...mapGetters(['getSelectedRunner']),
    runnersLoading () {
      return this.loading[loaders.RUNNERS]
    }
  },
  methods: {
    ...mapActions(['setSelectedRunner', 'fetchBets']),
    allBetsTotal () {
      let totalBets = 0
      this.runners.forEach((b) => {
        if (b.betsValue) {
          totalBets += b.betsValue
        }
      })
      return numeral(totalBets).format('0,0.00')
    },
    totalNoBets () {
      let totalBets = 0
      this.runners.forEach((b) => {
        if (b.betsCount) {
          totalBets += b.betsCount
        }
      })
      return numeral(totalBets).format('0a')
    }
  }
}
</script>

<style scoped>
.runnerDetails_header {
  height: 56px;
  /* background-color: black; */
}
.runnerDetails_header th {
  color: white;
}
.row-pointer >>> tbody tr :hover {
cursor: pointer;
}
</style>

<style>
.raceColumnShow {
  max-width:50px;
}
</style>
